<template>
  <form action="#" @submit.prevent="apply()">
    <div class="formsectioncompound">
      <div class="jq_gridcontentarea">
        <div class="wm-field small-12 columns">
          <fieldset>
            <legend>{{ $t('regionSelect.intro') }}</legend>
            <div class="wm-field-input">
              <ul class="wm-field-list">
                <li v-for="region in sortedRegions" :key="region.id">
                  <input :value="region.id"
                         :id="'regionSelectWebshopExample'+region.id"
                         :disabled="region.nrOfProductConfigurations === 0"
                         :checked="entitySelectionDraft.find(candidate => candidate.id === region.id)"
                         type="checkbox"
                         name="regionSelectWebshop"
                         @change="updateEntitySelectionDraft( region, $event.target.checked)">
                  <label :for="'regionSelectWebshopExample'+region.id">
                    {{ region.title }}
                  </label>
                </li>
              </ul>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
    <div class="formsectioncompound">
      <div class="jq_gridcontentarea">
        <div id="select_region" class="wm-field contentelement wm_form_element small-12 columns">
          <input :value="$t('regionSelect.buttonText')"
                 :disabled="entitySelectionDraft.length === 0"
                 type="submit"
                 name="select_region">
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { SET_SELECTED_REGIONS } from '../store/modules/selection/mutation-types'
import { mapGetters } from 'vuex'

export default {
  props: {},
  data: function () {
    return {
      isOpen: false,
      entitySelectionDraft: []
    }
  },
  computed: {
    ...mapGetters('shop', ['shopFilterEntityIds']),
    ...mapGetters('selection', [
      'sortedRegions',
      'availableSelectedRegions'
    ]),
    regions: function () {
      return this.sortedRegions
    },
    selectedRegions: function () {
      return [...this.availableSelectedRegions]
    }
  },
  watch: {
    selectedRegions: function (val, oldVal) {
      // if the real selection is changed (externally), our draft selection should be reset.
      if (val !== oldVal) {
        this.entitySelectionDraft = [...this.selectedRegions]
      }
    }
  },
  created: function () {
    this.entitySelectionDraft = [...this.selectedRegions]
  },
  methods: {
    updateEntitySelectionDraft (entity, include) {
      if (include) {
        this.entitySelectionDraft = [...this.entitySelectionDraft, entity]
      } else {
        this.entitySelectionDraft = this.entitySelectionDraft.filter(existing => existing.id !== entity.id)
      }
      this.$emit('regionSelectionDraftChanged', this.entitySelectionDraft)
    },
    apply: function () {
      this.$store.commit('selection/' + SET_SELECTED_REGIONS, this.entitySelectionDraft)
      this.$emit('regionSelectionChanged', this.entitySelectionDraft)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RegionSelector.vue